<div class="rp-rm">
  <div class="rp-pagehead">
    <div class="rp-pagehead-icon" aria-hidden="true">
      <svg viewBox="0 0 16 16" width="22" height="22" fill="currentColor"><path d="M5.5 3.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM2 12.25c0-1.79 1.7-3.25 3.5-3.25S9 10.46 9 12.25V13H2v-.75Zm8.5-3.25c1.8 0 3.5 1.46 3.5 3.25V13h-4.06c.04-.24.06-.49.06-.75 0-1.06-.4-2.03-1.06-2.79.48-.29 1.02-.46 1.56-.46Z"/></svg>
    </div>
    <div>
      <div class="rp-h1">Resource management</div>
      <div class="rp-desc">Organise this project's resources, working calendars and tags. These resources are available for assignment and scheduling on work packages.</div>
    </div>
  </div>

  <!-- Sub-nav tabs -->
  <div class="rp-tabs">
    <button [class.active]="tab==='resources'" (click)="tab='resources'">
      Resources <span class="rp-counter">{{ leafCount }}</span>
    </button>
    <button [class.active]="tab==='calendars'" (click)="tab='calendars'">
      Calendars <span class="rp-counter">{{ data.calendars.length }}</span>
    </button>
    <button [class.active]="tab==='tags'" (click)="tab='tags'">
      Tags <span class="rp-counter">{{ data.tags.length }}</span>
    </button>
  </div>

  <div class="rp-flash -ok" *ngIf="flash">{{ flash }}</div>
  <div class="rp-flash -error" *ngIf="error">{{ error }} <span class="rp-x" (click)="error=null"><span class="icon-close" aria-hidden="true"></span></span></div>
  <div class="rp-loading" *ngIf="loading">Loading…</div>

  <!-- ===================== RESOURCES ===================== -->
  <div *ngIf="!loading && tab==='resources'">
    <div class="rp-toolbar">
      <input class="rp-input rp-search" placeholder="Search resources…" [(ngModel)]="search" />
      <select class="rp-input rp-typefilter" [(ngModel)]="typeFilter">
        <option value="all">All types</option>
        <option *ngFor="let t of TYPES" [value]="t.key">{{ t.name }}</option>
      </select>

      <!-- tag filter (multi-select) -->
      <div class="rp-ms" *ngIf="data.tags.length">
        <button type="button" class="rp-ms-toggle" [class.-active]="tagFilter.length" (click)="tagFilterOpen = !tagFilterOpen"
                [attr.aria-expanded]="tagFilterOpen" title="Filter resources by tag">
          <svg class="rp-ms-icon" viewBox="0 0 16 16" width="13" height="13" fill="currentColor" aria-hidden="true"><path d="M1 7.775V2.75C1 1.784 1.784 1 2.75 1h5.025c.464 0 .91.184 1.238.513l6.25 6.25a1.75 1.75 0 0 1 0 2.474l-5.026 5.026a1.75 1.75 0 0 1-2.474 0l-6.25-6.25A1.75 1.75 0 0 1 1 7.775ZM4.5 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"/></svg>
          <span class="rp-ms-text" *ngIf="!tagFilter.length">All tags</span>
          <span class="rp-ms-chips" *ngIf="tagFilter.length">
            <span class="rp-tag" *ngFor="let tid of tagFilter.slice(0,2)"
                  [style.background]="tagColor((tagById(tid)?.color)||'gray').bg"
                  [style.color]="tagColor((tagById(tid)?.color)||'gray').fg">{{ tagById(tid)?.name }}</span>
            <span class="rp-ms-more" *ngIf="tagFilter.length > 2">+{{ tagFilter.length - 2 }}</span>
          </span>
          <span class="rp-ms-caret">▾</span>
        </button>
        <ng-container *ngIf="tagFilterOpen">
          <div class="rp-ms-backdrop" (click)="tagFilterOpen=false"></div>
          <div class="rp-ms-panel">
            <div class="rp-ms-head">
              <span>Filter by tag</span>
              <button type="button" class="rp-ms-clear" *ngIf="tagFilter.length" (click)="clearTagFilter()">Clear</button>
            </div>
            <label class="rp-ms-opt" *ngFor="let t of data.tags">
              <input type="checkbox" [checked]="tagFilter.includes(t.id)" (change)="toggleTagFilter(t.id)" />
              <span class="rp-dot" [style.background]="tagColor(t.color).dot"></span>
              <span class="rp-ms-opt-name">{{ t.name }}</span>
              <span class="rp-ms-opt-n">{{ tagUsage(t.id) }}</span>
            </label>
          </div>
        </ng-container>
      </div>

      <span class="rp-spacer"></span>
      <button class="rp-icon-btn" type="button" title="Expand all" aria-label="Expand all" (click)="expandAll()"><span class="icon-arrow-down2" aria-hidden="true"></span></button>
      <button class="rp-icon-btn" type="button" title="Collapse all" aria-label="Collapse all" (click)="collapseAll()"><span class="icon-arrow-up2" aria-hidden="true"></span></button>
      <button class="rp-btn" *ngIf="canManage" (click)="newResource(true)"><span class="rp-btn-ico">+</span><span>Group</span></button>
      <button class="rp-btn -primary" *ngIf="canManage" (click)="newResource(false)"><span class="rp-btn-ico">+</span><span>Resource</span></button>
    </div>

    <!-- Row controls are handled by ONE delegated listener on this container, not by
         per-row (click) bindings — see onDelegatedClick() in the component. -->
    <div class="rp-tree" (click)="onDelegatedClick($event)">
      <div class="rp-tree-head">
        <div>Resource</div><div>Tags</div><div class="-r">Max units</div><div class="-r">Rate</div><div class="-c">Calendar</div><div></div>
      </div>

      <div class="rp-empty" *ngIf="rows.length===0">No matching resources.</div>

      <div class="rp-row" *ngFor="let r of rows; trackBy: trackRow" [class.-group]="r.node.isGroup">
        <div class="rp-cell-name" [style.paddingLeft.px]="r.depth*22 + 8">
          <span class="rp-caret" *ngIf="r.node.isGroup" data-rp-act="res-toggle" [attr.data-rp-id]="r.node.id">{{ expanded.has(r.node.id) ? '▾' : '▸' }}</span>
          <span class="rp-caret -leaf" *ngIf="!r.node.isGroup"></span>
          <span class="rp-avatar" *ngIf="!r.node.isGroup" [style.background]="typeDef(r.node.resourceType).color">{{ r.node.initials }}</span>
          <span class="rp-folder icon-folder" *ngIf="r.node.isGroup" aria-hidden="true"></span>
          <span class="rp-namecol">
            <span class="rp-name" [class.-group]="r.node.isGroup">{{ r.node.name }}</span>
            <span class="rp-sub">{{ r.node.isGroup ? 'Group · ' + (r.node.children?.length || 0) + ' items' : typeDef(r.node.resourceType).name + ' · ' + (r.node.initials || '—') }}</span>
          </span>
        </div>

        <div class="rp-cell-tags">
          <ng-container *ngIf="!r.node.isGroup">
            <span class="rp-tag" *ngFor="let tid of r.node.tagIds.slice(0,3)"
                  [style.background]="tagColor((tagById(tid)?.color)||'gray').bg"
                  [style.color]="tagColor((tagById(tid)?.color)||'gray').fg">
              {{ tagById(tid)?.name }}
            </span>
            <span class="rp-muted" *ngIf="r.node.tagIds.length===0">—</span>
          </ng-container>
        </div>

        <div class="-r rp-mono">{{ r.node.isGroup ? '' : (typeDef(r.node.resourceType).hasUnits ? r.node.maxUnits + '%' : '—') }}</div>
        <div class="-r rp-mono">{{ r.node.isGroup ? '' : rateText(r.node) }}</div>
        <div class="rp-muted rp-trunc -c">{{ r.node.isGroup ? '' : calName(r.node.calendarId) }}</div>

        <div class="rp-actions" *ngIf="canManage">
          <button type="button" class="rp-icon" *ngIf="r.node.isGroup" title="Add resource" aria-label="Add resource"
                  data-rp-act="res-add" [attr.data-rp-id]="r.node.id"><span class="icon-add" aria-hidden="true"></span></button>
          <button type="button" class="rp-icon" title="Edit" aria-label="Edit"
                  data-rp-act="res-edit" [attr.data-rp-id]="r.node.id"><span class="icon-edit" aria-hidden="true"></span></button>
          <button type="button" class="rp-icon -danger" title="Delete" aria-label="Delete"
                  data-rp-act="res-delete" [attr.data-rp-id]="r.node.id"><span class="icon-delete" aria-hidden="true"></span></button>
        </div>
      </div>
    </div>

    <div class="rp-foot">{{ leafCount }} resources · {{ groupCount }} groups</div>
  </div>

  <!-- ===================== TAGS ===================== -->
  <div *ngIf="!loading && tab==='tags'">
    <div class="rp-toolbar">
      <span class="rp-spacer"></span>
      <button class="rp-btn -primary" *ngIf="canManage" (click)="newTag()">+ New tag</button>
    </div>
    <table class="rp-table" (click)="onDelegatedClick($event)">
      <thead><tr><th>Tag</th><th>Description</th><th class="-r">In use</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let t of data.tags">
          <td>
            <span class="rp-tag" [style.background]="tagColor(t.color).bg" [style.color]="tagColor(t.color).fg">
              <span class="rp-dot" [style.background]="tagColor(t.color).dot"></span>{{ t.name }}
            </span>
          </td>
          <td class="rp-muted">{{ t.description || '—' }}</td>
          <td class="-r">{{ tagUsage(t.id) }}</td>
          <td class="rp-actions" *ngIf="canManage">
            <button type="button" class="rp-icon" title="Edit" aria-label="Edit"
                    data-rp-act="tag-edit" [attr.data-rp-id]="t.id"><span class="icon-edit" aria-hidden="true"></span></button>
            <button type="button" class="rp-icon -danger" title="Delete" aria-label="Delete"
                    data-rp-act="tag-delete" [attr.data-rp-id]="t.id"><span class="icon-delete" aria-hidden="true"></span></button>
          </td>
        </tr>
        <tr *ngIf="data.tags.length===0"><td colspan="4" class="rp-empty">No tags yet.</td></tr>
      </tbody>
    </table>
  </div>

  <!-- ===================== CALENDARS ===================== -->
  <div *ngIf="!loading && tab==='calendars'">
    <div class="rp-toolbar">
      <span class="rp-spacer"></span>
      <button class="rp-btn -primary" *ngIf="canManage" (click)="newCalendar()">+ New calendar</button>
    </div>
    <div class="rp-cal-grid" (click)="onDelegatedClick($event)">
    <div class="rp-cal" *ngFor="let c of data.calendars">
      <div class="rp-cal-head">
        <span class="rp-cal-ico" aria-hidden="true"><span class="icon-calendar"></span></span>
        <span class="rp-name">{{ c.name }}</span>
        <span class="rp-badge" *ngIf="c.isDefault">Default</span>
        <span class="rp-spacer"></span>
        <button type="button" class="rp-cal-count" *ngIf="calUsage(c.id)"
                data-rp-act="cal-usage" [attr.data-rp-id]="c.id"
                [title]="'View resources on ' + c.name">
          <svg class="rp-cal-people" viewBox="0 0 16 16" width="12" height="12" fill="currentColor" aria-hidden="true"><path d="M5.5 3.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM2 12.25c0-1.79 1.7-3.25 3.5-3.25S9 10.46 9 12.25V13H2v-.75Zm8.5-3.25c1.8 0 3.5 1.46 3.5 3.25V13h-4.06c.04-.24.06-.49.06-.75 0-1.06-.4-2.03-1.06-2.79.48-.29 1.02-.46 1.56-.46Z"/></svg>
          {{ calUsage(c.id) }} {{ calUsage(c.id) === 1 ? 'resource' : 'resources' }}
        </button>
        <span class="rp-muted rp-cal-count -none" *ngIf="!calUsage(c.id)">No resources</span>
        <button type="button" class="rp-icon" *ngIf="canManage" title="Edit" aria-label="Edit"
                data-rp-act="cal-edit" [attr.data-rp-id]="c.id"><span class="icon-edit" aria-hidden="true"></span></button>
        <button type="button" class="rp-icon -danger" *ngIf="canManage" title="Delete" aria-label="Delete"
                data-rp-act="cal-delete" [attr.data-rp-id]="c.id"><span class="icon-delete" aria-hidden="true"></span></button>
      </div>
      <div class="rp-muted rp-cal-desc" *ngIf="c.description">{{ c.description }}</div>
      <div class="rp-cal-meta">
        <span class="rp-chip"><b>Days</b> {{ workingDayLabels(c.definition) }}</span>
        <span class="rp-chip"><b>Hours</b> {{ calHoursLabel(c.definition) }}</span>
        <span class="rp-chip"><b>Exceptions</b> {{ calExceptionCount(c.definition) }}</span>
        <span class="rp-chip" *ngIf="calParentName(c.definition)"><b>Inherits</b> {{ calParentName(c.definition) }}</span>
      </div>
    </div>
    </div>
    <div class="rp-empty" *ngIf="data.calendars.length===0">No calendars yet.</div>
  </div>

  <!-- ===================== RESOURCE DIALOG ===================== -->
  <div class="rp-overlay" *ngIf="resDialog">
    <div class="rp-dialog">
      <div class="rp-dialog-head">
        <span class="rp-dialog-title">
          <span class="rp-dialog-ico" aria-hidden="true">
            <svg *ngIf="resForm.isGroup" viewBox="0 0 16 16" width="17" height="17" fill="currentColor"><path d="M1.75 2.5A1.75 1.75 0 0 0 0 4.25v7.5C0 12.99.784 13.75 1.75 13.75h12.5A1.75 1.75 0 0 0 16 12V5.75A1.75 1.75 0 0 0 14.25 4H7.5L6.03 2.53a1.75 1.75 0 0 0-1.24-.53H1.75Z"/></svg>
            <svg *ngIf="!resForm.isGroup" viewBox="0 0 16 16" width="17" height="17" fill="currentColor"><path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6 6.25C2 11.9 4.69 10 8 10s6 1.9 6 4.25V15H2v-.75Z"/></svg>
          </span>
          {{ resForm.id ? 'Edit' : 'New' }} {{ resForm.isGroup ? 'group' : 'resource' }}
        </span>
        <button class="rp-icon" (click)="resDialog=false; error=null"><span class="icon-close" aria-hidden="true"></span></button>
      </div>
      <div class="rp-dialog-body">
        <!-- ══ GROUP MODE ══ -->
        <ng-container *ngIf="resForm.isGroup">
          <div class="rp-grouphint">
            <span class="rp-folder icon-folder" aria-hidden="true"></span>
            <span>Groups organise resources into a tree. You can nest groups and add resources to them after creating.</span>
          </div>
          <div class="rp-field">
            <label class="-req">Group name</label>
            <input class="rp-input" [(ngModel)]="resForm.name" placeholder="e.g. Civil, E&amp;I, Vijay Prabha" />
          </div>
          <div class="rp-field">
            <label>Parent group</label>
            <select class="rp-input" [(ngModel)]="resForm.parentId">
              <option [ngValue]="null">— Top level —</option>
              <option *ngFor="let g of groupOptions" [ngValue]="g.id">{{ g.name }}</option>
            </select>
          </div>
        </ng-container>

        <!-- ══ RESOURCE MODE ══ -->
        <ng-container *ngIf="!resForm.isGroup">
          <!-- live identity preview -->
          <div class="rp-idcard">
            <span class="rp-avatar -lg" [style.background]="typeDef(resForm.resourceType).color">
              {{ resForm.initials || (resForm.name ? resForm.name.substring(0,2).toUpperCase() : '?') }}
            </span>
            <div class="rp-idcard-body">
              <div class="rp-idcard-name">{{ resForm.name || 'New resource' }}</div>
              <div class="rp-idcard-sub">
                <span class="rp-dot" [style.background]="typeDef(resForm.resourceType).color"></span>
                {{ typeDef(resForm.resourceType).name }}<span *ngIf="typeDef(resForm.resourceType).hasUnits"> · {{ resForm.maxUnits || 0 }}% max</span><span *ngIf="typeDef(resForm.resourceType).hasRate && resForm.rate"> · {{ money(resForm.rate, resForm.currency) }}/h</span>
              </div>
            </div>
          </div>

          <!-- form tabs -->
          <div class="rp-dtabs">
            <button type="button" [class.active]="resTab==='details'" (click)="resTab='details'">Details</button>
            <button type="button" [class.active]="resTab==='tags'" (click)="resTab='tags'">
              Tags <span class="rp-counter" *ngIf="resForm.tagIds.length">{{ resForm.tagIds.length }}</span>
            </button>
            <button type="button" *ngIf="typeDef(resForm.resourceType).hasRate" [class.active]="resTab==='rates'" (click)="resTab='rates'">
              Rates <span class="rp-counter" *ngIf="totalRateTiers()">{{ totalRateTiers() }}</span>
            </button>
            <button type="button" *ngIf="typeDef(resForm.resourceType).hasUnits" [class.active]="resTab==='availability'" (click)="resTab='availability'">
              Availability <span class="rp-counter" *ngIf="resForm.availabilities.length">{{ resForm.availabilities.length }}</span>
            </button>
          </div>

          <!-- ── DETAILS ── -->
          <div class="rp-panel" *ngIf="resTab==='details'">
            <div class="rp-field">
              <label>Resource type</label>
              <div class="rp-type-grid">
                <button type="button" class="rp-type" *ngFor="let t of TYPES" [class.active]="resForm.resourceType===t.key"
                        [style.borderColor]="resForm.resourceType===t.key ? t.color : ''" (click)="setResType(t.key)">
                  <span class="rp-dot" [style.background]="t.color"></span>{{ t.name }}
                </button>
              </div>
            </div>
            <div class="rp-grid2">
              <div class="rp-field">
                <label class="-req">Name</label>
                <input class="rp-input" [(ngModel)]="resForm.name" (blur)="resForm.initials || autoInitials()" />
              </div>
              <div class="rp-field">
                <label>Initials (max 3)</label>
                <input class="rp-input" maxlength="3" [(ngModel)]="resForm.initials" />
              </div>
            </div>
            <div class="rp-field">
              <label>Parent group</label>
              <select class="rp-input" [(ngModel)]="resForm.parentId">
                <option [ngValue]="null">— Top level —</option>
                <option *ngFor="let g of groupOptions" [ngValue]="g.id">{{ g.name }}</option>
              </select>
            </div>

            <div class="rp-subhead">Capacity &amp; cost</div>
            <div class="rp-grid2">
              <div class="rp-field" *ngIf="typeDef(resForm.resourceType).hasUnits">
                <label>Max units (%)</label>
                <input class="rp-input" type="number" min="0" step="10" [(ngModel)]="resForm.maxUnits" />
              </div>
              <div class="rp-field">
                <label>Currency</label>
                <select class="rp-input" [(ngModel)]="resForm.currency">
                  <option *ngFor="let c of CURRENCIES" [value]="c">{{ c }}</option>
                </select>
              </div>
              <div class="rp-field" *ngIf="typeDef(resForm.resourceType).hasRate">
                <label>Standard rate /h</label>
                <input class="rp-input" type="number" min="0" [(ngModel)]="resForm.rate" />
              </div>
              <div class="rp-field" *ngIf="resForm.resourceType==='material'">
                <label>Unit label</label>
                <input class="rp-input" [(ngModel)]="resForm.unitLabel" placeholder="m³, t, …" />
              </div>
            </div>

            <div class="rp-subhead">Scheduling</div>
            <div class="rp-grid2">
              <div class="rp-field">
                <label>Calendar</label>
                <select class="rp-input" [(ngModel)]="resForm.calendarId">
                  <option [ngValue]="null">— None —</option>
                  <option *ngFor="let c of data.calendars" [ngValue]="c.id">{{ c.name }}</option>
                </select>
              </div>
              <div class="rp-field" *ngIf="typeDef(resForm.resourceType).hasUser">
                <label>Linked user</label>
                <select class="rp-input" [(ngModel)]="resForm.userId">
                  <option [ngValue]="null">— None —</option>
                  <option *ngFor="let m of members" [ngValue]="m.id">{{ m.name }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- ── TAGS ── -->
          <div class="rp-panel" *ngIf="resTab==='tags'">
            <p class="rp-section-hint">Tag resources to group and filter them. Click a tag to add it; click × to remove.</p>
            <div class="rp-taglist" *ngIf="resForm.tagIds.length">
              <span class="rp-tag" *ngFor="let tid of resForm.tagIds"
                    [style.background]="tagColor((tagById(tid)?.color)||'gray').bg"
                    [style.color]="tagColor((tagById(tid)?.color)||'gray').fg">
                <span class="rp-dot" [style.background]="tagColor((tagById(tid)?.color)||'gray').dot"></span>
                {{ tagById(tid)?.name }}
                <button type="button" class="rp-tag-x" (click)="toggleFormTag(tid)" [attr.aria-label]="'Remove ' + tagById(tid)?.name">×</button>
              </span>
            </div>
            <div class="rp-emptybox" *ngIf="!resForm.tagIds.length && data.tags.length">No tags selected yet.</div>
            <ng-container *ngIf="availableTags().length">
              <div class="rp-subhead">Add tags</div>
              <div class="rp-tagpick">
                <button type="button" class="rp-tag -pick" *ngFor="let t of availableTags()" (click)="toggleFormTag(t.id)">
                  <span class="rp-dot" [style.background]="tagColor(t.color).dot"></span>{{ t.name }}
                </button>
              </div>
            </ng-container>
            <span class="rp-muted" *ngIf="data.tags.length===0">No tags — create some in the Tags tab.</span>
          </div>

          <!-- ── RATES (cost rate tables A–E) ── -->
          <div class="rp-panel" *ngIf="resTab==='rates' && typeDef(resForm.resourceType).hasRate">
            <p class="rp-section-hint">Effective-dated rates (MS Project A–E). Empty tables fall back to the standard rate on Details.</p>
            <div class="rp-ratetabs">
              <button type="button" *ngFor="let k of RATE_TABLE_KEYS" [class.active]="rateTab===k" (click)="rateTab=k">
                {{ k }}<span class="rp-ratetab-n" *ngIf="rateRows(k).length">{{ rateRows(k).length }}</span>
              </button>
            </div>
            <div class="rp-ratetable">
              <div class="rp-rate-caption">{{ RATE_TABLE_NAMES[rateTab] }}</div>
              <div class="rp-rate-head" *ngIf="rateRows(rateTab).length">
                <div>Effective from</div><div class="-r">Rate /h</div><div></div>
              </div>
              <div class="rp-rate-row" *ngFor="let row of rateRows(rateTab); let i = index">
                <input class="rp-input" type="date" [(ngModel)]="row.effectiveDate" [name]="'rt'+rateTab+'d'+i" />
                <input class="rp-input -r" type="number" min="0" [(ngModel)]="row.rate" [name]="'rt'+rateTab+'r'+i" />
                <button class="rp-icon -danger" type="button" (click)="removeRateRow(rateTab, i)"><span class="icon-close" aria-hidden="true"></span></button>
              </div>
              <div class="rp-muted" *ngIf="rateRows(rateTab).length===0">No tiers — this table uses the standard rate.</div>
              <button class="rp-btn -sm" type="button" (click)="addRateRow(rateTab)">+ Add rate tier</button>
            </div>
          </div>

          <!-- ── AVAILABILITY over time ── -->
          <div class="rp-panel" *ngIf="resTab==='availability' && typeDef(resForm.resourceType).hasUnits">
            <p class="rp-section-hint">Vary max units across date ranges (e.g. 100% → 50%). Empty falls back to the max units on Details.</p>
            <div class="rp-avail-head" *ngIf="resForm.availabilities.length">
              <div>From</div><div>To</div><div class="-r">Max units %</div><div></div>
            </div>
            <div class="rp-avail-row" *ngFor="let a of resForm.availabilities; let i = index">
              <input class="rp-input" type="date" [(ngModel)]="a.from" [name]="'avf'+i" />
              <input class="rp-input" type="date" [(ngModel)]="a.to" [name]="'avt'+i" />
              <input class="rp-input -r" type="number" min="0" step="10" [(ngModel)]="a.maxUnits" [name]="'avm'+i" />
              <button class="rp-icon -danger" type="button" (click)="removeAvailability(i)"><span class="icon-close" aria-hidden="true"></span></button>
            </div>
            <div class="rp-emptybox" *ngIf="!resForm.availabilities.length">No availability ranges — uses the max units on Details.</div>
            <button class="rp-btn -sm" type="button" (click)="addAvailability()">+ Add availability range</button>
          </div>
        </ng-container>
      </div>
      <div class="rp-dialog-foot">
        <span class="rp-foot-error" *ngIf="error"><span class="icon-warning" aria-hidden="true"></span> {{ error }}</span>
        <button class="rp-btn -primary" (click)="saveResource()">{{ resForm.id ? 'Save' : 'Create' }}</button>
        <button class="rp-btn" (click)="resDialog=false; error=null">Cancel</button>
      </div>
    </div>
  </div>

  <!-- ===================== TAG DIALOG ===================== -->
  <div class="rp-overlay" *ngIf="tagDialog">
    <div class="rp-dialog -sm">
      <div class="rp-dialog-head"><span>{{ tagForm.id ? 'Edit' : 'New' }} tag</span><button class="rp-icon" (click)="tagDialog=false; error=null"><span class="icon-close" aria-hidden="true"></span></button></div>
      <div class="rp-dialog-body">
        <div class="rp-field"><label>Name *</label><input class="rp-input" [(ngModel)]="tagForm.name" /></div>
        <div class="rp-field">
          <label>Color</label>
          <div class="rp-colorpick">
            <button type="button" class="rp-swatch" *ngFor="let c of TAG_COLOR_KEYS" [class.on]="tagForm.color===c"
                    [style.background]="tagColor(c).dot" (click)="tagForm.color=c"></button>
          </div>
        </div>
        <div class="rp-field"><label>Description</label><input class="rp-input" [(ngModel)]="tagForm.description" /></div>
      </div>
      <div class="rp-dialog-foot">
        <span class="rp-foot-error" *ngIf="error"><span class="icon-warning" aria-hidden="true"></span> {{ error }}</span>
        <button class="rp-btn -primary" (click)="saveTag()">{{ tagForm.id ? 'Save' : 'Create' }}</button>
        <button class="rp-btn" (click)="tagDialog=false; error=null">Cancel</button>
      </div>
    </div>
  </div>

  <!-- ===================== CALENDAR DIALOG ===================== -->
  <div class="rp-overlay" *ngIf="calDialog">
    <div class="rp-dialog -wide">
      <div class="rp-dialog-head">
        <span class="rp-dialog-title">
          <span class="rp-dialog-ico" aria-hidden="true">
            <svg viewBox="0 0 16 16" width="17" height="17" fill="currentColor"><path d="M4.75 0a.75.75 0 0 1 .75.75V2h5V.75a.75.75 0 0 1 1.5 0V2h.25C13.44 2 14 2.56 14 3.25v9.5c0 .69-.56 1.25-1.25 1.25h-9.5C2.56 14 2 13.44 2 12.75v-9.5C2 2.56 2.56 2 3.25 2h.25V.75A.75.75 0 0 1 4.75 0ZM3.5 5.5v7h9v-7h-9Z"/></svg>
          </span>
          {{ calForm.id ? 'Edit' : 'New' }} calendar
        </span>
        <button class="rp-icon" (click)="calDialog=false; error=null"><span class="icon-close" aria-hidden="true"></span></button>
      </div>
      <div class="rp-dialog-body">
        <!-- identity (always visible above the tabs) -->
        <div class="rp-grid2">
          <div class="rp-field"><label class="-req">Name</label><input class="rp-input" [(ngModel)]="calForm.name" name="calName" placeholder="e.g. Standard (Mon–Fri)" /></div>
          <div class="rp-field">
            <label>Type</label>
            <select class="rp-input" [(ngModel)]="calForm.type" name="calType">
              <option *ngFor="let t of CAL_TYPES" [value]="t">{{ t }}</option>
            </select>
          </div>
        </div>
        <div class="rp-field"><label>Description</label><input class="rp-input" [(ngModel)]="calForm.description" name="calDesc" /></div>
        <div class="rp-grid2">
          <div class="rp-field">
            <label>Inherits from (base calendar)</label>
            <select class="rp-input" [(ngModel)]="calForm.parentCalendarId" name="calParent">
              <option [ngValue]="null">— None (standalone) —</option>
              <option *ngFor="let c of parentCalendarOptions" [ngValue]="c.id">{{ c.name }}</option>
            </select>
          </div>
          <label class="rp-check"><input type="checkbox" [(ngModel)]="calForm.isDefault" name="calDefault" /> Default calendar for this project</label>
        </div>

        <!-- tab bar -->
        <div class="rp-dtabs">
          <button type="button" [class.active]="calTab==='week'" (click)="calTab='week'">Working week</button>
          <button type="button" [class.active]="calTab==='exceptions'" (click)="calTab='exceptions'">
            Exceptions <span class="rp-counter" *ngIf="calForm.exceptions.length">{{ calForm.exceptions.length }}</span>
          </button>
          <button type="button" [class.active]="calTab==='weeks'" (click)="calTab='weeks'">
            Work weeks <span class="rp-counter" *ngIf="calForm.workWeeks.length">{{ calForm.workWeeks.length }}</span>
          </button>
          <button type="button" [class.active]="calTab==='advanced'" (click)="calTab='advanced'">Advanced</button>
        </div>

        <!-- ── Working week ── -->
        <div class="rp-panel" *ngIf="calTab==='week'">
          <p class="rp-section-hint">Per-day hours. “Default” inherits the base calendar. Night shifts: add two ranges (e.g. 22:00–24:00 and 00:00–06:00).</p>
          <div class="rp-weekday" *ngFor="let day of calForm.weekDays; let i = index" [class.-off]="day.type!=='WORKING'">
            <div class="rp-weekday-head">
              <span class="rp-weekday-name">{{ DOW[i] }}</span>
              <select class="rp-input -sm" [(ngModel)]="day.type" [name]="'wdType'+i">
                <option *ngFor="let t of DAY_TYPES" [value]="t.key">{{ t.label }}</option>
              </select>
              <span class="rp-weekday-sum" *ngIf="day.type==='WORKING'">{{ dayHoursLabel(day) }}</span>
            </div>
            <div class="rp-ranges" *ngIf="day.type==='WORKING'">
              <div class="rp-range" *ngFor="let h of day.hours; let j = index">
                <input class="rp-input -sm" type="time" [(ngModel)]="h.from" [name]="'wd'+i+'f'+j" />
                <span>–</span>
                <input class="rp-input -sm" type="time" [(ngModel)]="h.to" [name]="'wd'+i+'t'+j" />
                <button class="rp-icon -danger" type="button" (click)="removeRange(day, j)"><span class="icon-close" aria-hidden="true"></span></button>
              </div>
              <button class="rp-btn -sm" type="button" (click)="addRange(day)">+ Add range</button>
            </div>
          </div>
        </div>

        <!-- ── Advanced: conversion factors ── -->
        <div class="rp-panel" *ngIf="calTab==='advanced'">
          <p class="rp-section-hint">How MS Project converts durations (e.g. “2 days”) to working time.</p>
          <div class="rp-grid3">
            <div class="rp-field"><label>Minutes / day</label><input class="rp-input" type="number" min="0" [(ngModel)]="calForm.minutesPerDay" name="mpd" /></div>
            <div class="rp-field"><label>Minutes / week</label><input class="rp-input" type="number" min="0" [(ngModel)]="calForm.minutesPerWeek" name="mpw" /></div>
            <div class="rp-field"><label>Days / month</label><input class="rp-input" type="number" min="0" [(ngModel)]="calForm.daysPerMonth" name="dpm" /></div>
          </div>
        </div>

        <!-- ── Exceptions ── -->
        <div class="rp-panel" *ngIf="calTab==='exceptions'">
          <p class="rp-section-hint">Holidays, shutdowns and catch-up days. Supports date ranges and recurrence.</p>
          <div class="rp-emptybox" *ngIf="!calForm.exceptions.length">No exceptions yet.</div>
          <div class="rp-exception" *ngFor="let ex of calForm.exceptions; let i = index">
            <div class="rp-exception-row">
              <input class="rp-input" placeholder="Name (e.g. Christmas)" [(ngModel)]="ex.name" [name]="'exName'+i" />
              <button class="rp-icon -danger" type="button" (click)="removeException(i)"><span class="icon-close" aria-hidden="true"></span></button>
            </div>
            <div class="rp-exception-row">
              <div class="rp-field -inline"><label>From</label><input class="rp-input -sm" type="date" [(ngModel)]="ex.from" [name]="'exFrom'+i" /></div>
              <div class="rp-field -inline"><label>To</label><input class="rp-input -sm" type="date" [(ngModel)]="ex.to" [name]="'exTo'+i" /></div>
              <label class="rp-check"><input type="checkbox" [(ngModel)]="ex.working" (ngModelChange)="onExceptionWorkingChange(ex)" [name]="'exWork'+i" /> Working day</label>
            </div>
            <div class="rp-ranges" *ngIf="ex.working">
              <div class="rp-range" *ngFor="let h of ex.hours; let j = index">
                <input class="rp-input -sm" type="time" [(ngModel)]="h.from" [name]="'ex'+i+'f'+j" />
                <span>–</span>
                <input class="rp-input -sm" type="time" [(ngModel)]="h.to" [name]="'ex'+i+'t'+j" />
                <button class="rp-icon -danger" type="button" (click)="removeRange(ex, j)"><span class="icon-close" aria-hidden="true"></span></button>
              </div>
              <button class="rp-btn -sm" type="button" (click)="addRange(ex)">+ Add range</button>
            </div>
            <div class="rp-exception-row">
              <div class="rp-field -inline">
                <label>Repeat</label>
                <select class="rp-input -sm" [ngModel]="recurType(ex)" (ngModelChange)="onRecurTypeChange(ex, $event)" [name]="'exRec'+i">
                  <option *ngFor="let r of RECUR_TYPES" [value]="r.key">{{ r.label }}</option>
                </select>
              </div>
              <ng-container *ngIf="ex.recurring">
                <div class="rp-field -inline"><label>Every</label><input class="rp-input -sm -xs" type="number" min="1" [(ngModel)]="ex.recurring.every" [name]="'exEvery'+i" /></div>

                <!-- Weekly weekdays -->
                <div class="rp-recur-days" *ngIf="ex.recurring.type==='WEEKLY'">
                  <button type="button" class="rp-day -sm" *ngFor="let d of DAY_NAMES; let di = index"
                          [class.on]="ex.recurring.weekdays?.includes(d)" (click)="toggleRecurWeekday(ex, d)">{{ DOW[di] }}</button>
                </div>

                <!-- Monthly / Yearly relative toggle -->
                <label class="rp-check" *ngIf="ex.recurring.type==='MONTHLY' || ex.recurring.type==='YEARLY'">
                  <input type="checkbox" [(ngModel)]="ex.recurring.relative" [name]="'exRel'+i" /> On the …
                </label>
                <ng-container *ngIf="(ex.recurring.type==='MONTHLY' || ex.recurring.type==='YEARLY') && ex.recurring.relative">
                  <select class="rp-input -sm" [(ngModel)]="ex.recurring.ordinal" [name]="'exOrd'+i">
                    <option *ngFor="let o of ORDINALS" [value]="o">{{ o }}</option>
                  </select>
                  <select class="rp-input -sm" [(ngModel)]="ex.recurring.weekday" [name]="'exWd'+i">
                    <option *ngFor="let d of DAY_NAMES" [value]="d">{{ d }}</option>
                  </select>
                </ng-container>
                <div class="rp-field -inline" *ngIf="(ex.recurring.type==='MONTHLY' || ex.recurring.type==='YEARLY') && !ex.recurring.relative">
                  <label>Day</label><input class="rp-input -sm -xs" type="number" min="1" max="31" [(ngModel)]="ex.recurring.day" [name]="'exDay'+i" />
                </div>
                <div class="rp-field -inline" *ngIf="ex.recurring.type==='YEARLY'">
                  <label>Month</label>
                  <select class="rp-input -sm" [(ngModel)]="ex.recurring.month" [name]="'exMon'+i">
                    <option *ngFor="let m of MONTHS; let mi = index" [ngValue]="mi+1">{{ m }}</option>
                  </select>
                </div>
                <label class="rp-check" *ngIf="ex.recurring.type==='DAILY'">
                  <input type="checkbox" [(ngModel)]="ex.recurring.workingDaysOnly" [name]="'exWdo'+i" /> Working days only
                </label>

                <!-- Range end -->
                <div class="rp-field -inline">
                  <label>Ends</label>
                  <select class="rp-input -sm" [ngModel]="ex.recurring.range.kind" (ngModelChange)="onRangeKindChange(ex.recurring, $event)" [name]="'exRk'+i">
                    <option *ngFor="let k of RANGE_KINDS" [value]="k.key">{{ k.label }}</option>
                  </select>
                </div>
                <input class="rp-input -sm" type="date" *ngIf="ex.recurring.range.kind==='END_DATE'" [(ngModel)]="ex.recurring.range.date" [name]="'exRd'+i" />
                <input class="rp-input -sm -xs" type="number" min="1" *ngIf="ex.recurring.range.kind==='OCCURRENCES'" [(ngModel)]="ex.recurring.range.count" [name]="'exRc'+i" />
              </ng-container>
            </div>
          </div>
          <button class="rp-btn -sm" type="button" (click)="addException()">+ Add exception</button>
        </div>

        <!-- ── Work weeks ── -->
        <div class="rp-panel" *ngIf="calTab==='weeks'">
          <p class="rp-section-hint">Dated weekly overrides (e.g. a half-day Christmas week). Days left “Default” inherit the base working week.</p>
          <div class="rp-emptybox" *ngIf="!calForm.workWeeks.length">No work weeks yet.</div>
          <div class="rp-workweek" *ngFor="let ww of calForm.workWeeks; let wi = index">
            <div class="rp-exception-row">
              <input class="rp-input" placeholder="Name" [(ngModel)]="ww.name" [name]="'wwName'+wi" />
              <div class="rp-field -inline"><label>From</label><input class="rp-input -sm" type="date" [(ngModel)]="ww.from" [name]="'wwFrom'+wi" /></div>
              <div class="rp-field -inline"><label>To</label><input class="rp-input -sm" type="date" [(ngModel)]="ww.to" [name]="'wwTo'+wi" /></div>
              <button class="rp-icon -danger" type="button" (click)="removeWorkWeek(wi)"><span class="icon-close" aria-hidden="true"></span></button>
            </div>
            <div class="rp-weekday" *ngFor="let day of ww.weekDays; let i = index">
              <div class="rp-weekday-head">
                <span class="rp-weekday-name">{{ DOW[i] }}</span>
                <select class="rp-input -sm" [(ngModel)]="day.type" [name]="'ww'+wi+'d'+i">
                  <option *ngFor="let t of DAY_TYPES" [value]="t.key">{{ t.label }}</option>
                </select>
                <span class="rp-weekday-sum" *ngIf="day.type==='WORKING'">{{ dayHoursLabel(day) }}</span>
              </div>
              <div class="rp-ranges" *ngIf="day.type==='WORKING'">
                <div class="rp-range" *ngFor="let h of day.hours; let j = index">
                  <input class="rp-input -sm" type="time" [(ngModel)]="h.from" [name]="'ww'+wi+'d'+i+'f'+j" />
                  <span>–</span>
                  <input class="rp-input -sm" type="time" [(ngModel)]="h.to" [name]="'ww'+wi+'d'+i+'t'+j" />
                  <button class="rp-icon -danger" type="button" (click)="removeRange(day, j)"><span class="icon-close" aria-hidden="true"></span></button>
                </div>
                <button class="rp-btn -sm" type="button" (click)="addRange(day)">+ Add range</button>
              </div>
            </div>
          </div>
          <button class="rp-btn -sm" type="button" (click)="addWorkWeek()">+ Add work week</button>
        </div>
      </div>
      <div class="rp-dialog-foot">
        <span class="rp-foot-error" *ngIf="error"><span class="icon-warning" aria-hidden="true"></span> {{ error }}</span>
        <button class="rp-btn -primary" (click)="saveCalendar()">{{ calForm.id ? 'Save' : 'Create' }}</button>
        <button class="rp-btn" (click)="calDialog=false; error=null">Cancel</button>
      </div>
    </div>
  </div>

  <!-- ===================== CALENDAR RESOURCES MODAL ===================== -->
  <div class="rp-overlay" *ngIf="calResModal" (click)="closeCalResources()">
    <div class="rp-dialog -sm" (click)="$event.stopPropagation()">
      <div class="rp-dialog-head">
        <span class="rp-dialog-title">
          <span class="rp-dialog-ico" aria-hidden="true">
            <svg viewBox="0 0 16 16" width="17" height="17" fill="currentColor"><path d="M5.5 3.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm5 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM2 12.25c0-1.79 1.7-3.25 3.5-3.25S9 10.46 9 12.25V13H2v-.75Zm8.5-3.25c1.8 0 3.5 1.46 3.5 3.25V13h-4.06c.04-.24.06-.49.06-.75 0-1.06-.4-2.03-1.06-2.79.48-.29 1.02-.46 1.56-.46Z"/></svg>
          </span>
          {{ calUsage(calResModal.id) }} {{ calUsage(calResModal.id) === 1 ? 'resource' : 'resources' }} on {{ calResModal.name }}
        </span>
        <button class="rp-icon" (click)="closeCalResources()"><span class="icon-close" aria-hidden="true"></span></button>
      </div>
      <div class="rp-dialog-body">
        <div class="rp-reslist">
          <button type="button" class="rp-reslist-row" *ngFor="let r of calResources(calResModal.id)"
                  (click)="closeCalResources(); editResource(r)" [title]="'Edit ' + r.name">
            <span class="rp-avatar" [style.background]="typeDef(r.resourceType).color">{{ r.initials }}</span>
            <span class="rp-reslist-main">
              <span class="rp-reslist-name">{{ r.name }}</span>
              <span class="rp-reslist-sub">{{ typeDef(r.resourceType).name }}<span *ngIf="typeDef(r.resourceType).hasUnits"> · {{ r.maxUnits }}% max</span><span *ngIf="typeDef(r.resourceType).hasRate && r.rate"> · {{ money(r.rate, r.currency) }}/h</span></span>
            </span>
            <span class="rp-reslist-go" aria-hidden="true">›</span>
          </button>
        </div>
      </div>
      <div class="rp-dialog-foot">
        <button class="rp-btn" (click)="closeCalResources()">Close</button>
      </div>
    </div>
  </div>
</div>
